export default __webpack_public_path__ + "static/media/group_350_90.5e6dad7f.png";